import { useMemo } from 'react';
import { useAppSelector } from '@/core/global-store';

/** Tenant super admin (company owner from register / website signup). */
export function useIsTenantSuperAdmin(): boolean {
    const user = useAppSelector((s) => s.auth.user);
    const me = useAppSelector((s) => s.auth.me);

    return useMemo(() => {
        if (user?.role === 'super_admin') {
            return true;
        }
        const role = (me as Record<string, unknown> | null)?.role;
        if (role === 'super_admin') {
            return true;
        }
        const roles = (me as Record<string, unknown> | null)?.roles as
            | Array<{ name?: string; slug?: string }>
            | undefined;
        if (!Array.isArray(roles)) {
            return false;
        }
        return roles.some((r) => r.slug === 'super_admin' || r.name === 'super admin');
    }, [user?.role, me]);
}
